import React, { useState, useEffect } from 'react';
import { Link, NavLink } from 'react-router-dom';

// Logo import kaldırıldı

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  // Scroll olayını dinle
  useEffect(() => {
    const handleScroll = () => {
      // Sayfa 50px'den fazla scroll edildiğinde header'ı fixed hale getir
      if (window.scrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    // Scroll olayını dinlemeye başla
    window.addEventListener('scroll', handleScroll);

    // Component unmount olduğunda event listener'ı temizle
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  const navItems = [
    { text: 'Ana Sayfa', route: '/' },
    { text: 'Hakkımızda', route: '/hakkimizda' },
    { text: 'Hizmetler', route: '/hizmetler' },
    { text: 'Neden Biz', route: '/neden-biz' },
    { text: 'İletişim', route: '/iletisim' }
  ];

  return (
    <>
      {/* Sayfa scroll edildiğinde boşluk bırakmak için kullanılan placeholder */}
      {isScrolled && <div className="h-[72px]"></div>}
      
      <header 
        className={`bg-white shadow-md w-full z-50 transition-all duration-300 ${
          isScrolled ? 'fixed top-0 left-0 right-0 shadow-lg animate-slideDown' : ''
        }`}
      >
        <div className="container-custom py-4">
          <div className="flex justify-between items-center">
            {/* Logo yerine metin logo */}
            <Link to="/" className="flex items-center" onClick={closeMenu}>
              <div className="text-2xl font-bold text-primary">
                Cihangir Nakliyat
              </div>
            </Link>

            {/* Desktop Navigation */}
            <nav className="hidden md:flex space-x-8">
              {navItems.map((item, index) => (
                <NavLink
                  key={index}
                  to={item.route}
                  className={({ isActive }) =>
                    isActive
                      ? 'text-primary font-semibold'
                      : 'text-secondary hover:text-primary transition-colors'
                  }
                >
                  {item.text}
                </NavLink>
              ))}
            </nav>

            {/* Mobile Menu Button */}
            <button
              className="md:hidden text-secondary focus:outline-none"
              onClick={toggleMenu}
              aria-label={isMenuOpen ? 'Menüyü kapat' : 'Menüyü aç'}
            >
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                {isMenuOpen ? (
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M6 18L18 6M6 6l12 12"
                  />
                ) : (
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M4 6h16M4 12h16M4 18h16"
                  />
                )}
              </svg>
            </button>
          </div>

          {/* Mobile Navigation */}
          {isMenuOpen && (
            <nav className="md:hidden mt-4 pb-4">
              <div className="flex flex-col space-y-4">
                {navItems.map((item, index) => (
                  <NavLink
                    key={index}
                    to={item.route}
                    className={({ isActive }) =>
                      isActive
                        ? 'text-primary font-semibold'
                        : 'text-secondary hover:text-primary transition-colors'
                    }
                    onClick={closeMenu}
                  >
                    {item.text}
                  </NavLink>
                ))}
              </div>
            </nav>
          )}
        </div>
      </header>
    </>
  );
};

export default Header; 